<template>
  <vodal class="sales-popup"
    :show="show || forceShow"
    :closeButton="false"
    :closeOnClickMask="false"
    :animation="slideSetting.popup_effect || 'slideUp'">
    <Lottie :key="`animBg-${animBgKey}`" :data="anims.bg[animBgKey]" class="popup--bg-anim fixed inset-0" />
    <div class="wrapper h-full w-full flex items-center justify-center relative" :class="`frame-${frameKey}`">
    <!-- <div class="wrapper h-full w-full flex items-center justify-center relative" :class="`frame-1`"> -->
      <div v-if="content" class="inner-content w-full">
        <p class="-dep text-5xl text-center">{{content.department}}</p>
        <p class="-figure absolute font-extrablack text-4xl tracking-wider leading-7">{{content.inText}}</p>
      </div>
      <!-- <Lottie :key="3" :data="anims.fg[3]" -->
      <Lottie :key="animFgKey" :data="anims.fg[animFgKey]"
        class="popup--fg-anim absolute" />
    </div>
  </vodal>
</template>

<script>
import Vodal from 'vodal'
import { mapGetters } from 'vuex'

import Lottie from './Lottie'

const bgAnims = [
  require('../../assets/animations/confetti-1.json'),
  require('../../assets/animations/confetti-2.json'),
  require('../../assets/animations/confetti-3.json'),
  require('../../assets/animations/confetti-4.json'),
  require('../../assets/animations/confetti-5.json'),
  require('../../assets/animations/confetti-6.json'),
  require('../../assets/animations/confetti-7.json'),
  require('../../assets/animations/confetti-8.json'),
  require('../../assets/animations/confetti-9.json'),
  require('../../assets/animations/confetti-10.json'),
  require('../../assets/animations/confetti-11.json'),
]

const fgAnims = [
  require('../../assets/animations/fg-1.json'),
  require('../../assets/animations/fg-2.json'),
  require('../../assets/animations/fg-3.json'),
  require('../../assets/animations/fg-4.json'),
]

export default {
  components: {
    Vodal,
    Lottie,
  },
  props: {
    content: Object,
    forceShow: Boolean
  },
  data() {
    return {
      show: false,
      anims: {
        bg: bgAnims,
        fg: fgAnims
      }

    }
  },
  computed: {
    ...mapGetters([
      'slideSetting',
      'popupSound',
    ]),
    dataKey() {
      return (this.content && this.content._key) || 0
    },
    frameKey() {
      return this.dataKey % 2
    },
    animBgLength() {
      return this.anims.bg.length
    },
    animBgKey() {
      return this.dataKey % this.animBgLength
    },
    animFgLength() {
      return this.anims.fg.length
    },
    animFgKey() {
      return this.dataKey % this.animFgLength
    }
  },
  watch: {
    show(shouldShow) {
      if(shouldShow && this.popupSound) {
        console.log('🚀 ~ file: SalesPopup.vue ~ line 94 ~ show ~ shouldShow', shouldShow)
        this.popupSound.play()
      }
    },
    content(newVal) {
      if(newVal) {
        this.show = true
        setTimeout(() => {
          this.show = false
          this.$emit('reset')
        }, (this.slideSetting.popup_time || 5) * 1000)
      }
    }
  }
}
</script>

<style scoped>
.popup--fg-anim {
  transform: rotate(15deg);
  bottom: 20%;
  width: 16rem;
  right: -3.5rem;
}
</style>
